import { Seo } from 'components/Seo';
import { useParams } from 'react-router-dom';

export default function Statistics(){
  let params = useParams();
  return (
    <><Seo title="Min statistikk" /><iframe src={`https://statistikk.1881.no/KundeRapport/${params.id}?showmonth=3`} title="Frima statistikk"></iframe></>
  )
}